export { LOCATION_TYPES, getLocation, getDisplayName } from './types';
export type {
  RentalLocation,
  SearchDestinationType,
  SearchSuggestion,
} from './types';
export { useSearchSuggestions } from './useSearchSuggestions';
